import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import * as fromModel from '../models';
import { Constant } from '../../../environments/constants';




export const INIT_CHART_DATA: fromModel.IChartData = {
  action: fromModel.CHART_DATA_ACTION.NONE,
  actionDispatchedBy: 'Initial',
  actionHistory: [],
  ChartSeries: [],
};

@Injectable({
  providedIn: 'root'
})
export class ChartDataService {

  protected chartDataSubject: BehaviorSubject<fromModel.IChartData>;
  public chartData: fromModel.IChartData; 

  constructor() { 
    this.chartData = JSON.parse(JSON.stringify(INIT_CHART_DATA));
    this.chartDataSubject = new BehaviorSubject<fromModel.IChartData>(this.chartData);
  }

  public subscribe(callback: (context: fromModel.IChartData) => void): Subscription{
    return this.chartDataSubject.subscribe(callback);    
  }

  public dispatchAction(act: fromModel.CHART_DATA_ACTION, dispatchedBy: string, payload: any | null): void {
    console.log(`%c Chart Data - Action: ${act}; By: ${dispatchedBy}`, Constant.consoleLogStyle.documentContext);
    this.chartData.action = act;
    this.chartData.actionDispatchedBy = dispatchedBy;
    this.chartData.actionHistory.push(`${act}: ${dispatchedBy}`);
    let _contextUpdateReq = true;

    switch (act){
      case fromModel.CHART_DATA_ACTION.NONE:
        console.log('%c App Context - No Action', Constant.consoleLogStyle.documentContext);
        break;
      case fromModel.CHART_DATA_ACTION.RESET:  
        console.log('%c Reset App Context', Constant.consoleLogStyle.documentContext);
        this.chartData = JSON.parse(JSON.stringify(INIT_CHART_DATA));      
        break;
      case fromModel.CHART_DATA_ACTION.CHARTSERIES:
        if(this.chartData.ChartSeries && this.chartData.ChartSeries.length > 0){
          const chartSer = this.chartData.ChartSeries.find(cs=>cs.chartSeriesType === payload.chartSeriesType);
          if(chartSer){
            const chartSerPos = this.chartData.ChartSeries.indexOf(chartSer);
            if(chartSerPos>-1){
              this.chartData.ChartSeries.splice(chartSerPos, 1);
            }          
          }          
        }
        this.chartData.ChartSeries.push(payload);
        break;      

    }
    // console.log(JSON.stringify(this.context));  
    const dispatchedContext: fromModel.IChartData = JSON.parse(JSON.stringify(this.chartData));    
    this.chartDataSubject.next(dispatchedContext);
  } 
 
}
